import { createRoot } from 'react-dom/client'
import App from '@/App'
import '@/App.css'

// expose debug
Object.assign(window, { debug: process.env.DEBUG === '1' })

const root = createRoot(document.querySelector('#app-root')!)
root.render(<App />)
